<script setup>
import { ref, watch } from 'vue'
import { isValidNumber } from '@/services/utils'

const props = defineProps({
  modelValue: [String, Number]
})
const emit = defineEmits(['update:modelValue'])

const internal = ref(props.modelValue ?? '')

watch(() => props.modelValue, (v) => {
  internal.value = v ?? ''
})

function onInput() {
  if (internal.value === '' || internal.value === null) {
    emit('update:modelValue', internal.value)
    return
  }
  if (isValidNumber(internal.value)) {
    emit('update:modelValue', Number(internal.value))
  } else {
    emit('update:modelValue', internal.value)
  }
}

</script>

<template>
  <v-text-field
    type="text"
    v-model="internal"
    @input="onInput"
    density="compact"
    hide-details
    class="standings-field"
  />
</template>